import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonBaseState, initialCommonBaseState } from "../../interfaces/redux/common";
import { logoutReducers, resetErrors, setError } from "../common/commonActions";
import { RootState } from "../store";
import { loadDerivMappings, loadEventDerivItem, setLoading, setReloading } from "./derivActions";
import { Deriv, DerivMapping } from "../../interfaces/dtos/deriv";

export interface DerivState extends CommonBaseState {
    reloading: boolean;
    loadingDerivMappings: boolean;

    eventDerivs: Deriv[];
    derivMappings: DerivMapping[];
}

const initialState: DerivState = {
    ...initialCommonBaseState,
    reloading: false,
    loadingDerivMappings: false,

    eventDerivs: [],
    derivMappings: []
};

export const derivSlice = createSlice({
    name: 'deriv',
    initialState,
    reducers: {
        errorOccured: (state, action: PayloadAction<string>) => {
            state.error = true;
            state.errorMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // loadEventDerivItem
            .addCase(loadEventDerivItem.fulfilled, (state, action) => {
                state.eventDerivs = action.payload;
            })
            .addCase(loadEventDerivItem.rejected, (state, action) => {
                if (action.error.message?.indexOf("404") === -1) {
                    state.error = true;
                    state.errorMessage = `Could not load deriv:\r\n${action.error.message}`;
                }
            })

            // loadDerivMappings
            .addCase(loadDerivMappings.pending, (state) => {
                state.loadingDerivMappings = true;
            })
            .addCase(loadDerivMappings.fulfilled, (state, action) => {
                state.loadingDerivMappings = false;
                state.derivMappings = action.payload;
            })
            .addCase(loadDerivMappings.rejected, (state, action) => {
                state.loadingDerivMappings = false;
                state.error = true;
                state.errorMessage = `Could not load deriv mappings:\r\n${action.error.message}`;
            })

            // Set loading
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loading = action.payload;
            })

            // Set reloading
            .addCase(setReloading.fulfilled, (state, action) => {
                state.reloading = action.payload;
            })

            // Set error
            .addCase(setError.fulfilled, (state, action) => {
                state.error = true;
                state.errorMessage = action.payload;
            })
            // Reset errors
            .addCase(resetErrors.fulfilled, (state) => {
                state.error = false;
            })
            // Logout
            .addCase(logoutReducers.fulfilled, () => {
                return { ...initialState };
            });
    }
});

export const { errorOccured } = derivSlice.actions;
export const derivState = (state: RootState) => state.deriv;
export default derivSlice.reducer;
